'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Menu;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _caligramReact = require('caligram-react');

var _containers = require('../containers');

var _components = require('../components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Menu(_ref) {
  var showMobile = _ref.showMobile,
      showMobileAction = _ref.showMobileAction;

  return _react2.default.createElement(
    'nav',
    { className: 'Menu ' + (showMobile ? 'showMobile' : '') },
    _react2.default.createElement(_containers.SearchBarContainer, null),
    _react2.default.createElement(
      'ul',
      null,
      _react2.default.createElement(
        'li',
        { onClick: showMobileAction },
        _react2.default.createElement(
          _reactRouter.IndexLink,
          { to: '/', activeClassName: 'current' },
          'Accueil'
        )
      ),
      _react2.default.createElement(
        'li',
        { onClick: showMobileAction },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/types', activeClassName: 'current' },
          'Par type'
        )
      ),
      _react2.default.createElement(
        'li',
        { onClick: showMobileAction },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/mots-cles', activeClassName: 'current' },
          'Par mot-cl\xE9'
        )
      ),
      _react2.default.createElement(
        'li',
        { onClick: showMobileAction },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/lieux', activeClassName: 'current' },
          'Par lieu'
        )
      ),
      _react2.default.createElement(
        'li',
        { onClick: showMobileAction },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/groupes', activeClassName: 'current' },
          'Par groupe'
        )
      ),
      _react2.default.createElement(
        'li',
        { className: 'mobile-only' },
        _react2.default.createElement(
          'a',
          { href: '/evenements#filters' },
          'Par date'
        )
      ),
      _react2.default.createElement(
        'li',
        { className: 'mobile-only add', onClick: showMobileAction },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: { pathname: '/inscrire-une-activite' } },
          'Inscrire une activit\xE9'
        )
      ),
      _react2.default.createElement(
        'li',
        { className: 'desktop-only add', onClick: showMobileAction },
        _react2.default.createElement(
          _reactRouter.Link,
          { className: 'Button primary fit iconRight', to: { pathname: '/inscrire-une-activite' } },
          _react2.default.createElement(
            'span',
            null,
            'Inscrire une activit\xE9'
          ),
          _react2.default.createElement(_caligramReact.Icon, { name: 'chevronRight' })
        )
      )
    ),
    _react2.default.createElement(
      'ul',
      null,
      _react2.default.createElement(
        'li',
        { className: 'mobile-only external' },
        _react2.default.createElement(_components.ExternalCalendarLink, null)
      ),
      _react2.default.createElement(
        'li',
        { className: 'mobile-only external' },
        _react2.default.createElement(_components.ExternalProgramsLink, null)
      )
    ),
    _react2.default.createElement(_caligramReact.Button, { title: 'Fermer', className: 'close', iconLeft: 'chevronUp', action: showMobileAction })
  );
}

Menu.propTypes = {
  showMobile: _react.PropTypes.bool
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu.js
// module id = 1118
// module chunks = 0